export enum ITEM_TYPE {
  TARIFF = 'tariff',
  CTN = 'ctn',
  PRODUCT = 'product',
  SERVICE = 'service',
}

export enum CLIENT_TYPE {
  B2C = 'b2c',
  B2B = 'b2b',
}
